<div *ngIf="item" class="bgc-white-4">
    <!-- #region Order id -->
    <div layout-gt-sm="row" layout="column" *ngIf="!item.id && !item.useFirstNewNumber && !item.orderId">
        <mat-form-field flex layout-margin>
            <mat-label i18n>Order number</mat-label>
            <vd-select [(ngModel)]="item.orderId" #orderId="ngModel" endpoint="order" layout="column" name="orderId" required placeholder="Order number" i18n-placeholder flex>
                <ng-template vd-select-option let-row="option">
                    <span>{{row?.number}}</span>
                </ng-template>
            </vd-select>
            <mat-error *ngIf="orderId.errors?.required"><span i18n>Order</span><span i18n> is required</span></mat-error>
        </mat-form-field>
    </div>
    <!-- #endregion -->

    <!-- #region Assigned phone numbers -->
    <div layout-gt-sm="row" layout="column" *ngIf="!item.id && !item.useFirstNewNumber && item.orderId > 0">
        <mat-form-field flex layout-margin>
            <mat-label i18n>Assigned phone number</mat-label>
            <vd-select [(ngModel)]="item.assignedPhoneNumberId" (itemChange)="setPhoneNumber($event)" #assignedPhoneNumber="ngModel" endpoint="order/assignedPhoneNumbers/{{item.orderId}}" layout="column" name="assignedPhoneNumber" required placeholder="Assigned phone number" i18n-placeholder flex>
                <ng-template vd-select-option let-row="option">
                    <span>({{row?.nationalDestinationCode}}) {{row?.subscriberNumber}}</span>
                </ng-template>
            </vd-select>
            <mat-error *ngIf="assignedPhoneNumber.errors?.required"><span i18n>Assigned phone number</span><span i18n> is required</span></mat-error>
        </mat-form-field>
    </div>
    <!-- #endregion -->

    <div layout-gt-sm="row" layout="column" *ngIf="item.phoneNumber">
        <!-- #region NationalDestinationCode -->
        <mat-form-field flex layout-margin>
            <mat-label i18n>Phone prefix</mat-label>
            <input matInput name="nationalDestinationCode{{id}}" [(ngModel)]="item.phoneNumber.nationalDestinationCode" #nationalDestinationCode="ngModel" readonly="true" placeholder="Phone prefix" i18n-placeholder>
            <mat-error *ngIf="nationalDestinationCode.errors?.required"><span i18n>Phone prefix</span><span i18n> is required</span></mat-error>
        </mat-form-field>
        <!-- #endregion -->

        <!-- #region SubscriberNumber -->
        <mat-form-field flex layout-margin>
            <mat-label i18n>Phone number</mat-label>
            <input matInput name="subscriberNumber{{id}}" [(ngModel)]="item.phoneNumber.subscriberNumber" #subscriberNumber="ngModel" readonly="true" placeholder="Phone number" i18n-placeholder>
            <mat-error *ngIf="subscriberNumber.errors?.required"><span i18n>Phone number</span><span i18n> is required</span></mat-error>
        </mat-form-field>
        <!-- #endregion -->
    </div>

    <div layout-gt-sm="row" layout="column">
        <!-- #region Honorific -->
        <mat-form-field flex layout-margin>
            <mat-label i18n>Title</mat-label>
            <input matInput name="honorific{{id}}" [(ngModel)]="item.person.honorific" #honorific="ngModel" [disabled]="disabled" [readonly]="readonly" placeholder="Title" i18n-placeholder>
            <mat-error *ngIf="honorific.errors?.required"><span i18n>Title</span><span i18n> is required</span></mat-error>
        </mat-form-field>
        <!-- #endregion -->

        <!-- #region Heraldic -->
        <mat-form-field flex layout-margin>
            <mat-label i18n>Heraldic</mat-label>
            <input matInput name="heraldic{{id}}" [(ngModel)]="item.person.heraldic" #heraldic="ngModel" [disabled]="disabled" [readonly]="readonly" placeholder="Heraldic" i18n-placeholder>
            <mat-error *ngIf="heraldic.errors?.required"><span i18n>Heraldic</span><span i18n> is required</span></mat-error>
        </mat-form-field>
        <!-- #endregion -->
    </div>

    <div layout-gt-sm="row" layout="column">
        <!-- #region Surname -->
        <mat-form-field flex layout-margin>
            <mat-label i18n>Name</mat-label>
            <input matInput name="surname{{id}}" [(ngModel)]="item.person.surname" #surname="ngModel" [disabled]="disabled" [readonly]="readonly" required placeholder="Name" i18n-placeholder>
            <mat-error *ngIf="surname.errors?.required"><span i18n>Name</span><span i18n> is required</span></mat-error>
        </mat-form-field>
        <!-- #endregion -->

        <!-- #region GivenName -->
        <mat-form-field flex layout-margin>
            <mat-label i18n>First name</mat-label>
            <input matInput name="givenName{{id}}" [(ngModel)]="item.person.givenName" #givenName="ngModel" [disabled]="disabled" [readonly]="readonly" placeholder="First name" i18n-placeholder>
            <mat-error *ngIf="givenName.errors?.required"><span i18n>First name</span><span i18n> is required</span></mat-error>
        </mat-form-field>
        <!-- #endregion -->

        <!-- #region occupationalTitle -->
        <mat-form-field flex layout-margin>
            <mat-label i18n>Occupational title</mat-label>
            <input matInput name="occupationalTitle{{id}}" [(ngModel)]="item.person.occupationalTitle" #occupationalTitle="ngModel" [disabled]="disabled" [readonly]="readonly" placeholder="Occupational title" i18n-placeholder>
            <mat-error *ngIf="occupationalTitle.errors?.required"><span i18n>Occupational title</span><span i18n> is required</span></mat-error>
        </mat-form-field>
        <!-- #endregion -->
    </div>

    <div layout="row" flex>
        <!-- #region Number usage -->
        <mat-form-field flex layout-margin>
            <mat-label i18n>Number usage</mat-label>
            <vd-select [(ngModel)]="item.numberUsage" [enum]="NumberUsage" name="numberUsage{{id}}" #numberUsage="ngModel" placeholder="Number usage" [disabled]="readonly" i18n-placeholder required flex></vd-select>
            <mat-error *ngIf="numberUsage.errors?.required"><span i18n>Number usage</span><span i18n> is required</span></mat-error>
        </mat-form-field>
        <!-- #endregion -->

        <!-- #region Directory assistance -->
        <mat-form-field flex layout-margin>
            <mat-label i18n>Directory assistance</mat-label>
            <vd-select [(ngModel)]="item.directoryAssistance" [enum]="DirectoryAssistance" name="directoryAssistance{{id}}" #directoryAssistance="ngModel" [disabled]="readonly" placeholder="Directory assistance" i18n-placeholder required flex></vd-select>
            <mat-error *ngIf="directoryAssistance.errors?.required"><span i18n>Directory assistance</span><span i18n> is required</span></mat-error>
        </mat-form-field>
        <!-- #endregion -->

        <!-- #region Search index -->
        <mat-form-field flex layout-margin>
            <mat-label i18n>Search index</mat-label>
            <vd-select [(ngModel)]="item.searchIndex" [enum]="SearchIndex" name="searchIndex{{id}}" #searchIndex="ngModel" placeholder="Search index" [disabled]="readonly" i18n-placeholder required flex></vd-select>
            <mat-error *ngIf="searchIndex.errors?.required"><span i18n>Search index</span><span i18n> is required</span></mat-error>
        </mat-form-field>
        <!-- #endregion -->
    </div>

    <div layout="row" flex>
        <!-- #region Address output -->
        <mat-form-field flex layout-margin>
            <mat-label i18n>Address output</mat-label>
            <vd-select [(ngModel)]="item.addressOutput" [enum]="AddressOutput" name="addressOutput{{id}}" #addressOutput="ngModel" placeholder="Address output" [disabled]="readonly" i18n-placeholder required flex></vd-select>
            <mat-error *ngIf="addressOutput.errors?.required"><span i18n>Address output</span><span i18n> is required</span></mat-error>
        </mat-form-field>
        <!-- #endregion -->

        <!-- #region White pages -->
        <mat-form-field flex layout-margin>
            <mat-label i18n>White pages</mat-label>
            <vd-select [(ngModel)]="item.whitePages" [enum]="WhitePages" name="whitePages{{id}}" #whitePages="ngModel" placeholder="White pages" [disabled]="readonly" i18n-placeholder required flex></vd-select>
            <mat-error *ngIf="whitePages.errors?.required"><span i18n>White pages</span><span i18n> is required</span></mat-error>
        </mat-form-field>
        <!-- #endregion -->

        <!-- #region Electronic info -->
        <mat-form-field flex layout-margin>
            <mat-label i18n>Electronic info</mat-label>
            <vd-select [(ngModel)]="item.electronicInfo" [enum]="ElectronicInfo" name="electronicInfo{{id}}" #electronicInfo="ngModel" placeholder="Electronic info" [disabled]="readonly" i18n-placeholder required flex></vd-select>
            <mat-error *ngIf="electronicInfo.errors?.required"><span i18n>Electronic info</span><span i18n> is required</span></mat-error>
        </mat-form-field>
        <!-- #endregion -->
    </div>

    <!-- #region Inverse search -->
    <div layout-gt-sm="row" layout="column">
        <div layout-margin class="push-top">
            <mat-checkbox name="inverseSearch{{id}}" [(ngModel)]="item.inverseSearch" [disabled]="readonly" i18n>Inverse search</mat-checkbox>
        </div>
    </div>
    <!-- #endregion -->

    <!-- #region useFirstNewNumber -->
    <div layout-gt-sm="row" layout="column" *ngIf="item.useFirstNewNumber">
        <div layout-margin class="push-top">
            <mat-checkbox name="useFirstNewNumber{{id}}" [(ngModel)]="item.useFirstNewNumber" disabled="true" i18n>Use first new number</mat-checkbox>
        </div>
    </div>
    <!-- #endregion -->
</div>

<!-- #region Custom fields -->
<ng-content select="[footer]" flex></ng-content>
<!-- #endregion -->